import React, { useState } from 'react';
import * as PropTypes from 'prop-types';
import { useMatchesMinWidth } from '../../hooks/useMatchesMinWidth';
import { BREAKPOINTS } from '../../../constants';
import pages from '../../define/pages.js';

import ViewMobile from './ViewMobile';
import ViewDesktop from './ViewDesktop';
import BetaIcon, { IconColors, IconSizes } from '../Icons/Icon';
import SmartSearch from '../SmartSearch/SmartSearch.js';

import { ModalOneTap } from '../modals';
import { useAuth0 } from '../../context/auth0';

const NavigationMenu = (props) => {
  const isDeviceSmallerThanMblLandscape = !useMatchesMinWidth(
    BREAKPOINTS.MBL_HEADER
  );
  const isDeviceSmallerThanTablet = !useMatchesMinWidth(BREAKPOINTS.MBL_HEADER);

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const mostPopularCategories = JSON.parse(props.mostPopularCategories);
  const categoriesByPopularity = JSON.parse(props.categoriesByPopularity);
  const isSearchResultsPage = window.location.pathname === pages.catalogue;

  const { isAuthenticated } = useAuth0();

  const openMobileMenu = (value) => {
    setIsMobileMenuOpen(value);
    if (value) {
      document.body.classList.add('block-overflow');
    } else {
      document.body.classList.remove('block-overflow');
    }
  };

  return (
    <>
      {isDeviceSmallerThanMblLandscape ? (
        <>
          <div className="d-flex gap-xs">
            <span
              className={
                props.showSearch && !isSearchResultsPage
                  ? 'ui-kit-visible'
                  : 'ui-kit-hidden'
              }
            >
              <SmartSearch
                isNavSearch={true}
                isIconOnly={isDeviceSmallerThanTablet}
                isNavTransparent={props.isTransparent}
              />
            </span>
            <div onClick={() => openMobileMenu(true)}>
              <BetaIcon
                name={'hamburger'}
                color={
                  props.isTransparent ? IconColors.ghost : IconColors.regular
                }
                size={IconSizes[24]}
              />
            </div>
          </div>
          <ViewMobile
            isOpen={isMobileMenuOpen}
            onClickClose={() => openMobileMenu(false)}
            mostPopularCategories={mostPopularCategories}
            categoriesByPopularity={categoriesByPopularity}
          />
          {!isAuthenticated && <ModalOneTap key="otp" />}
        </>
      ) : (
        <>
          <ViewDesktop
            prefixesAreVisible={props.prefixesAreVisible}
            navbarStyle={props.isTransparent}
            mostPopularCategories={mostPopularCategories}
            categoriesByPopularity={categoriesByPopularity}
          />
          {!isAuthenticated && <ModalOneTap key="otp" hasBanner={props?.hasBanner || false} />}
        </>
      )}
    </>
  );
};

NavigationMenu.propTypes = {
  isTransparent: PropTypes.bool.isRequired,
  isAbsolute: PropTypes.bool.isRequired,
  prefixesAreVisible: PropTypes.string,
  showSearch: PropTypes.bool,
};

NavigationMenu.defaultProps = {
  isTransparent: false,
  isAbsolute: false,
};

NavigationMenu.sanitizeProps = (props) => ({
  ...props,
  isTransparent: props.isTransparent === 'true',
  isAbsolute: props.isAbsolute === 'true',
});

export default NavigationMenu;
